import React, { useState } from 'react';
import Toggle from 'components/common/Toggle'

const DurationOption = (props) => {
    const { slideDuration, setLivefeedOptionsHandle, setLivefeedGlobalOptionsHandle } = props
    const [globalDuration, setGlobalDuration] = useState(false);
    return (
        <div className="duration-grid-item">
            <div className="editor-container">
                <div className="header grid-item">DURATION</div>
                <span className="editor-text grid-item grid-item__title"
                    data-for="floorplanOptionsTooltip"
                    data-tip="Duration&nbsp;(in&nbsp;seconds)&nbsp;before changing&nbsp;to&nbsp;next&nbsp;slide"
                    style={{ whiteSpace: "normal" }}>
                    Choose slide duration: {slideDuration} s</span>
                <div className="editor-text grid-item duration-button">
                    <input type="range" id="slideDuration" min="5" max="45"
                        onChange={(event) => {
                            /* if globalDuration is enabled, then when the duration is modified, set globalDuration to be false*/
                            globalDuration === true && setGlobalDuration(false)
                            setLivefeedOptionsHandle(parseInt(event.target.value))
                        }}
                        value={slideDuration} />
                    <div className="indicator">{slideDuration} seconds</div>
                    <div className="marker pull-left">5</div>
                    <div className="marker pull-right">45</div>
                </div>
                <div className="editor-text grid-item global-toggle-item">
                    <div
                        data-tip="Apply&nbsp;this&nbsp;slide duration&nbsp;to&nbsp;all&nbsp;slides"
                        data-for="floorplanOptionsTooltip"
                        style={{ whiteSpace: "normal" }}
                        className="global-option-toggle"
                        onClick={() => {
                            setGlobalDuration(!globalDuration);
                            setLivefeedGlobalOptionsHandle(slideDuration)
                        }}>
                        <div className="toggle-text">Apply to all slides</div>
                        <Toggle isActive={globalDuration} />
                    </div>
                </div>
            </div>
        </div>
    );
}


export default DurationOption;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/DurationOption/index.jsx